import React, { useEffect, useState } from "react";
import { Content, Row, Col, Box, Button } from "adminlte-2-react";
import moment from "moment";
import _ from "lodash";
import TimeInput from "react-time-picker-input";
import controller from "./duck";
import serviciosController from "../servicios/duck";
import { useSelector, useDispatch } from "react-redux";
import SelectInput from "../utils/SelectInput";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { responseSelector } from "../utils/helpers/selectors";
import Loader from "../utils/Loader";
import ReferenciaObligatorios from "../utils/etiquetaObligatorio/ReferenciaObligatorios";
import Etiqueta from "../utils/etiquetaObligatorio/Etiqueta";

function AddAusencia({ history, match }) {
  const dispatch = useDispatch();

  const modelAddAusencia = useSelector((state) => state.addAusencia);
  const modelProfesionales = useSelector(
    (state) => state.profesionalesForSelect
  );

  const [profesional, setProfesional] = useState("");
  const [profesionalesOptions, setProfesionalesOptions] = useState([]);
  const [fecha, setFecha] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [horaInicio, setHoraInicio] = useState("07:00");
  const [horaFin, setHoraFin] = useState("21:00");
  const [intervalos, setIntervalos] = useState([]);

  useEffect(() => {
    const data = modelProfesionales?.data?.data?.data;
    const error = modelProfesionales?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(serviciosController.duckProfesionalesForSelect.actions.clear());
    }
    if (data) {
      setProfesionalesOptions(data);

      dispatch(serviciosController.duckProfesionalesForSelect.actions.clear());
    }
  }, [modelProfesionales]);

  useEffect(() => {
    if (match.params.categoria === "60f806a5e3e9af972fe85c7a") {
      dispatch(
        serviciosController.profesionalesForSelectThunk(match.params.id, true)
      );
    } else {
      dispatch(
        serviciosController.profesionalesForSelectThunk(match.params.id)
      );
    }
  }, []);

  useEffect(() => {
    const { data, error } = responseSelector(modelAddAusencia);

    if (error) {
      alert(error);
      dispatch(controller.createAusenciaDuck.actions.clear());
    }
    if (data) {
      history.push(
        `/ausenciasProfesionales/${match.params.id}/${match.params.categoria}`
      );
      dispatch(controller.createAusenciaDuck.actions.clear());
    }
  }, [modelAddAusencia]);

  function submit() {
    if (!profesional || !fecha || intervalos.length === 0) {
      alert("Por favor complete todos los campos");
      return;
    }

    let data = {
      localId: match.params.id,
      profesionalId: profesional,
      intervalos,
      fecha: moment(fecha).format("YYYY-MM-DD"),
      fechaFin: moment(fechaFin).format("YYYY-MM-DD"),
    };
    dispatch(controller.createAusenciaThunk(data));
  }

  function handleRangos(inicio, fin) {
    if (fin <= inicio) {
      return alert("El final del rango es menor o igual al inicio");
    }
    let intervalosAux = [...intervalos];
    const nuevoRango = {
      inicio,
      fin,
    };
    const coincide = intervalos.filter(
      (fila) =>
        (inicio >= fila.inicio && inicio < fila.fin) ||
        (fin > fila.inicio && fin <= fila.fin) ||
        (inicio <= fila.inicio && fin >= fila.fin) ||
        (inicio <= fila.inicio && fin >= fila.fin)
    );

    if (coincide.length > 0) {
      return alert("Rango coincide con uno previamente cargado");
    }

    intervalosAux.push(nuevoRango);
    setIntervalos(intervalosAux);
  }

  function deleteRango(dia, index) {
    let intervalosAux = [...intervalos];

    intervalosAux.splice(index, 1);
    setIntervalos(intervalosAux);
  }
  return (
    <Content title="Nueva ausencia" browserTitle="Nueva ausencia" show={false}>
      <Row>
        <Col md="6" mdOffset="3">
          <Box
            title="Nueva ausencia"
            footer={
              <>
                <Button
                  text="Cancelar"
                  disabled={false}
                  onClick={() => {
                    history.push(
                      `/ausenciasProfesionales/${match.params.id}/${match.params.categoria}`
                    );
                  }}
                />

                <Button
                  type="primary"
                  text={
                    <Loader
                      loaderColor="#ffffff"
                      isLoading={modelAddAusencia.loading}
                    >
                      Guardar
                    </Loader>
                  }
                  pullRight={true}
                  disabled={modelAddAusencia.loading}
                  onClick={() => submit()}
                />
              </>
            }
          >
            <ReferenciaObligatorios />

            <SelectInput
              value={profesional}
              setValue={setProfesional}
              label={
                <Etiqueta
                  texto={
                    match.params.categoria === "60f806a5e3e9af972fe85c7a"
                      ? "Ambiente"
                      : "Profesional"
                  }
                  obligatorio={true}
                />
              }
              options={profesionalesOptions}
            />

            <label>
              <Etiqueta texto="Fecha de inicio" obligatorio={true} />
            </label>
            <DatePicker

              dateFormat="dd/MM/yyyy"
              customInput={<input type="text" className="form-control" />}
              selected={fecha}
              onChange={(date) => {

                setFecha(date);
              }}
              minDate={new Date()}
            />

            <label style={{ marginTop: 15 }}>
              <Etiqueta texto="Fecha final" obligatorio={true} />
            </label>
            <DatePicker

              dateFormat="dd/MM/yyyy"
              customInput={<input type="text" className="form-control" />}
              selected={fechaFin}
              onChange={(date) => {

                setFechaFin(date);
              }}
              minDate={new Date()}
            />

            <label style={{ marginTop: 15 }}>
              <Etiqueta texto="Intervalos" obligatorio={true} />
            </label>
            <>
              <Col lg="12">
                {intervalos.map((row, index) => (
                  <div key={index}>
                    <Col lg="4">
                      <text>
                        <strong>Desde: {row.inicio}</strong>
                      </text>
                    </Col>
                    <Col lg="4">
                      <text>
                        <strong>Hasta: {row.fin}</strong>
                      </text>
                    </Col>
                    <Col lg="4" style={{ paddingBottom: 20 }}>
                      <Button
                        type="danger"
                        text="Eliminar intervalo"
                        onClick={() => deleteRango(index)}
                      />
                    </Col>
                  </div>
                ))}
              </Col>
              <Col lg="12">
                <Col style={{ zIndex: 2 }} lg="4">
                  <text>
                    <strong>Desde</strong>
                  </text>
                  <TimeInput eachInputDropdown manuallyDisplayDropdown value={horaInicio} onChange={setHoraInicio} />
                </Col>
              </Col>
              <Col lg="12">
                <Col style={{ zIndex: 1 }} lg="4">
                  <text>
                    <strong>Hasta</strong>
                  </text>
                  <TimeInput eachInputDropdown manuallyDisplayDropdown value={horaFin} onChange={setHoraFin} />
                </Col>
                <Col lg="12">
                  <Col lg="4" style={{ marginTop: 25 }}>
                    <Button
                      type="primary"
                      text="Añadir intervalo"
                      onClick={() => handleRangos(horaInicio, horaFin)}
                    />
                  </Col>
                </Col>
              </Col>
            </>
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default AddAusencia;
